import React from 'react';
import classNames from 'classnames';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { HorizontalDivider } from '../dividers';
import styles from './start-root-box-section.module.scss';
import { StartRootBoxSectionComponent } from './start-root-box-section-component';
const StartRootBoxSectionNoMemo = ({ isListEmpty, someoneIsTyping, appHeaderIsVisible, shouldShowCommentBox, boxRating, ...sortProps }) => {
    const { hideHeaderDivider } = useConfiguration();
    const { isMobile } = useApi((state, actions, _, ctx) => ({
        isMobile: getIsMobile(state),
        biAttemptLoginSignup: actions.biAttemptLoginSignup,
        requestLoginAction: actions.requestLogin,
    }));
    const shouldShowDivider = appHeaderIsVisible && !hideHeaderDivider;
    return (React.createElement("div", { className: classNames(styles.root, isMobile && styles.isMobile, appHeaderIsVisible && !!hideHeaderDivider && styles.withTopMargin, !shouldShowCommentBox && styles.withoutCommentBox) },
        shouldShowDivider ? React.createElement(HorizontalDivider, { className: styles.divider, type: "header" }) : null,
        React.createElement(StartRootBoxSectionComponent, { shouldShowCommentBox: shouldShowCommentBox, hideSort: sortProps.hideSort, selectedSort: sortProps.selectedSort, isListEmpty: isListEmpty, boxRating: boxRating, someoneIsTyping: someoneIsTyping })));
};
const StartRootBoxSection = React.memo(StartRootBoxSectionNoMemo);
export default StartRootBoxSection;
//# sourceMappingURL=start-root-box-section.js.map